<template>
    <div class="form-box mb10" v-loading="loading">
        <el-form inline :model="formData" size="mini" ref="formInline" @submit.native.prevent="handleOnSubmit">

            <el-form-item prop="is_used" v-if="getCustomFilterShow('is_used')">
                <CustomInput label='使用状态'>
                    <SelectAll :options="defaultOptions['is_used']" v-model="formData.is_used" />
                    <template #append></template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="material_id" v-if="getCustomFilterShow('material_id')">
                <CustomInput label='素材名称' @append-click=" handleGenAppendClick('material_id', '输入或粘贴名称，每行一个')">
                    <ESelect v-model="formData.material_id" filterable placeholder="请输入素材名称搜索选择" multiple
                        collapse-tags remote reserve-keyword :loading="searchLoading" ref="material_id"
                        @visible-change="(val)=>handleVisibleChange(val, 'material_id')"
                        :remote-method="(search) => throttleAppEntrySearchList(search, 'material_name')">
                        <p class="option-select">
                            <el-button type="text"
                                @click="()=>handleSelectAll(material_name_DataList, 'material_id', 'all')">全选</el-button>
                            <el-button type="text"
                                @click="()=>handleSelectAll(material_name_DataList, 'material_id', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option v-for="item in material_name_DataList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </ESelect>
                    <template #appendOrther>
                        <div :style="{ color: 'red', display: 'inline-block' }">
                            <i class="el-icon-close" @click="handleDel('material_id')" />
                        </div>
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="material_md5" v-if="getCustomFilterShow('material_md5')">
                <CustomInput label='素材MD5' @append-click=" handleGenAppendClick('material_md5', '输入或粘贴MD5，每行一个')">
                    <ESelect v-model="formData.material_md5" filterable clearable placeholder="请输入素材MD5搜索选择" multiple
                        collapse-tags remote reserve-keyword :loading="searchLoading" ref="material_md5"
                        @visible-change="(val)=>handleVisibleChange(val, 'material_md5')"
                        :remote-method="(search) => throttleAppEntrySearchList(search, 'material_md5')">
                        <p class="option-select">
                            <el-button type="text"
                                @click="()=>handleSelectAll(material_md5_DataList, 'material_md5', 'all')">全选</el-button>
                            <el-button type="text"
                                @click="()=>handleSelectAll(material_md5_DataList, 'material_md5', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option v-for="item in material_md5_DataList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy" />
                        <!--                        <div :style="{color: 'red', display: 'inline-block', borderLeft: '1px solid #DCDFE6', paddingLeft: '8px',marginLeft: '10px'}">-->
                        <!--                            <i class="el-icon-close" @click="handleDel('material_md5')"/>-->
                        <!--                        </div>-->
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="material_type" v-if="getCustomFilterShow('material_type')">
                <CustomInput label='素材类型'>
                    <SelectAll :options="defaultOptions['material_type']" v-model="formData.material_type" />
                    <template #append></template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="material_format" v-if="getCustomFilterShow('material_format')">
                <CustomInput label='素材格式'>
                    <SelectAll :options="defaultOptions['material_format']" v-model="formData.material_format" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('material_format')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="material_w_h" v-if="getCustomFilterShow('material_w_h')">
                <CustomInput label='素材尺寸'>
                    <SelectAll :options="material_w_h_DataList" v-model="formData.material_w_h" />
                    <template #append></template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="material_size" v-if="getCustomFilterShow('material_size')">
                <CustomInput label='素材大小'>
                    <template #prepend>
                        <el-select style="width:106px" v-model="formData.material_size_unit" slot="prepend"
                            placeholder="请选择" class="customInput_prepend_select">
                            <el-option value="1" label="素材大小(KB)"></el-option>
                            <el-option value="2" label="素材大小(MB)"></el-option>
                        </el-select>
                    </template>
                    <el-input clearable style="width:140px" placeholder="小于等于" :value="formData.material_size"
                        @input="(val)=>changeNum(val, 'material_size')" @keyup.enter.native="handleOnSubmit"></el-input>
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('material_size')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="label_ids" v-if="getCustomFilterShow('label_ids')">
                <CustomInput label='素材标签'>
                    <SelectAll :options="label_ids_DataList" v-model="formData.label_ids" :group=true />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('label_ids')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="source" v-if="getCustomFilterShow('source')">
                <CustomInput label='内部来源'>
                    <SelectAll :options="defaultOptions['source']" v-model="formData.source" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('source')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="producer_uid" v-if="getCustomFilterShow('producer_uid')">
                <CustomInput label='制作人'>
                    <SelectAll :options="production_user_DataList" v-model="formData.producer_uid" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('producer_uid')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="material_group" v-if="getCustomFilterShow('material_group')">
                <CustomInput label='制作部门'>
                    <!-- <SelectAll :options="material_group_DataList" v-model="formData.material_group"/> -->
                    <cascader-all :options="material_group_DataList" :width="200" :lineHeight="28"
                        v-model="formData.material_group" clearable ref="cascaderAll" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('material_group')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="upload_time" v-if="getCustomFilterShow('upload_time')">
                <CustomInput label='素材上传时间'>
                    <el-date-picker v-model="formData.upload_time" type="daterange" range-separator="至"
                        start-placeholder="开始日期" prefix-icon="" clearable value-format="yyyy-MM-dd"
                        end-placeholder="结束日期" :picker-options="basePickerOptions">
                    </el-date-picker>
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('upload_time')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="project_id" v-if="getCustomFilterShow('project_id')">
                <CustomInput label='项目名称' @append-click="handleGenAppendClick('project_id', '输入或粘贴名称，每行一个')">
                    <ESelect v-model="formData.project_id" filterable clearable placeholder="请输入项目名称搜索选择" multiple
                        collapse-tags remote reserve-keyword :loading="searchLoading" ref="project_id"
                        @visible-change="(val)=>handleVisibleChange(val, 'project_id')"
                        :remote-method="(search) => throttleAppEntrySearchList(search, 'project_id')">
                        <p class="option-select">
                            <el-button type="text"
                                @click="()=>handleSelectAll(project_id_DataList, 'project_id', 'all')">全选</el-button>
                            <el-button type="text"
                                @click="()=>handleSelectAll(project_id_DataList, 'project_id', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option v-for="item in project_id_DataList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy" />
                        <!--                        <div :style="{color: 'red', display: 'inline-block', borderLeft: '1px solid #DCDFE6', paddingLeft: '8px',marginLeft: '10px'}">-->
                        <!--                            <i class="el-icon-close" @click="handleDel('project_name')"/>-->
                        <!--                        </div>-->
                    </template>
                </CustomInput>
            </el-form-item>



            <el-form-item prop="project_type" v-if="getCustomFilterShow('project_type')">
                <CustomInput label='指定项目'>
                    <SelectAll :options="defaultOptions['project_type']" v-model="formData.project_type" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('project_type')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="app_type" v-if="getCustomFilterShow('app_type')">
                <CustomInput label='产品类型'>
                    <SelectAll :options="defaultOptions['app_type']" v-model="formData.app_type" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('app_type')" />
                    </template>
                </CustomInput>
            </el-form-item>
            <el-form-item prop="package_type" v-if="getCustomFilterShow('package_type')">
                <CustomInput label='包体类型'>
                    <SelectAll :options="defaultOptions['package_type']" v-model="formData.package_type" />
                    <template #append>
                        <i class="el-icon-close" :style="{ color: 'red' }" @click="handleDel('package_type')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="game_classify" v-if="getCustomFilterShow('game_classify')">
                <CustomInput label='游戏分类'>
                    <SelectAll :options="defaultOptions['game_classify']" v-model="formData.game_classify"
                        :disabled="game_classify_disabled" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('game_classify')" />
                    </template>
                </CustomInput>
            </el-form-item>


            <el-form-item prop="work_order" v-if="getCustomFilterShow('work_order')">
                <CustomInput label='工单' @append-click="handleGenAppendClick('work_order', '输入或粘贴名称或ID，每行一个')">
                    <ESelect v-model="formData.work_order" filterable clearable placeholder="请输入工单名称、ID搜索" multiple
                        collapse-tags remote reserve-keyword :loading="searchLoading" ref="work_order"
                        @visible-change="(val)=>handleVisibleChange(val, 'work_order')"
                        :remote-method="(search) => throttleAppEntrySearchList(search, 'work_order')">
                        <p class="option-select">
                            <el-button type="text"
                                @click="()=>handleSelectAll(work_order_DataList, 'work_order', 'all')">全选</el-button>
                            <el-button type="text"
                                @click="()=>handleSelectAll(work_order_DataList, 'work_order', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option v-for="item in work_order_DataList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy" />
                    </template>
                    <template #appendOrther>
                        <div :style="{color: 'red', display: 'inline-block'}">
                            <i class="el-icon-close" @click="handleDel('work_order')" />
                        </div>
                    </template>
                </CustomInput>
            </el-form-item>


            <el-form-item prop="detail_id" v-if="getCustomFilterShow('detail_id')">
                <CustomInput label='任务ID' @append-click="handleGenAppendClick('detail_id', '输入或粘贴ID，每行一个')">
                    <ESelect v-model="formData.detail_id" filterable clearable placeholder="请输入任务ID搜索" multiple
                        collapse-tags remote reserve-keyword :loading="searchLoading" ref="detail_id"
                        @visible-change="(val)=>handleVisibleChange(val, 'detail_id')"
                        :remote-method="(search) => throttleAppEntrySearchList(search, 'detail_id')">
                        <p class="option-select">
                            <el-button type="text"
                                @click="()=>handleSelectAll(detail_id_DataList, 'detail_id', 'all')">全选</el-button>
                            <el-button type="text"
                                @click="()=>handleSelectAll(detail_id_DataList, 'detail_id', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option v-for="item in detail_id_DataList" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy" />
                    </template>
                    <template #appendOrther>
                        <div :style="{color: 'red', display: 'inline-block'}">
                            <i class="el-icon-close" @click="handleDel('work_order')" />
                        </div>
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="plat_id" v-if="getCustomFilterShow('plat_id')">
                <CustomInput label='媒体'>
                    <SelectAll :options="defaultOptions['plat']" :multiple="false" v-model="formData.plat_id" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('plat_id')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="delivery_scene" v-if="getCustomFilterShow('delivery_scene')">
                <CustomInput label='投放场景'>
                    <SelectAll :options="defaultOptions['delivery_scene']" :multiple="false"
                        v-model="formData.delivery_scene" noDataText="请选择媒体" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('delivery_scene')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="delivery_type" v-if="getCustomFilterShow('delivery_type')">
                <CustomInput label='投放版位'>
                    <SelectAll :options="defaultOptions['delivery_type']" :multiple="false"
                        v-model="formData.delivery_type" noDataText="请选择投放场景" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('delivery_type')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="create_order_uid" v-if="getCustomFilterShow('create_order_uid')">
                <CustomInput label='需求方'>
                    <SelectAll :options="create_order_uid_DataList" v-model="formData.create_order_uid" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('create_order_uid')" />
                    </template>
                </CustomInput>
            </el-form-item>

            <el-form-item prop="create_material_group" v-if="getCustomFilterShow('create_material_group')">
                <CustomInput label='需求方部门'>
                    <!-- <SelectAll :options="create_material_group_DataList" v-model="formData.create_material_group"/> -->
                    <cascader-all :options="create_material_group_DataList" :width="200" :lineHeight="28"
                        v-model="formData.create_material_group" clearable ref="cascaderAllGroup" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('create_material_group')" />
                    </template>
                </CustomInput>
            </el-form-item>
            <el-form-item prop="project_tag11" v-if="getCustomFilterShow('project_tag11')">
                <CustomInput label='游戏类型'>
                    <SelectAll :options="defaultOptions['project_tag11']" 
                        v-model="formData.project_tag11" noDataText="请选择游戏类型" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('project_tag11')" />
                    </template>
                </CustomInput>
            </el-form-item>
            <el-form-item prop="project_tag12" v-if="getCustomFilterShow('project_tag12')">
                <CustomInput label='游戏题材'>
                    <SelectAll :options="defaultOptions['project_tag12']" 
                        v-model="formData.project_tag12" noDataText="请选择游戏题材" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('project_tag12')" />
                    </template>
                </CustomInput>
            </el-form-item>
            <el-form-item prop="material_label" v-if="getCustomFilterShow('material_label')">
                <CustomInput label='素材分类标签'>
                    <SelectAll :options="material_label_DataList" 
                        v-model="formData.material_label" noDataText="请选择素材分类标签" />
                    <template #append>
                        <i class="el-icon-close" :style="{color: 'red'}" @click="handleDel('material_label')" />
                    </template>
                </CustomInput>
            </el-form-item>
            

            <el-form-item>
                <FilterPopSelect :list="listMap" :value="customFilter" @change="changeFilter" />
            </el-form-item>
        </el-form>
        <div class="opts">
            <el-button type="primary" size="mini" v-matomo="{behaviorCategory: '素材库', event: '点击',  name: '筛选(查询)' }"
                @click="handleOnSubmit">查询</el-button>
            <el-button size="mini" v-matomo="{behaviorCategory: '素材库', event: '点击',  name: '筛选(清空筛选)' }"
                @click="resetForm('formInline')">清空筛选</el-button>
        </div>
    </div>
</template>

<script>

import CustomInput from '@/components/CustomInput'
import FilterPopSelect from '../../../components/filterPopSelect';
import SelectAll from '@/components/SelectAll';
import CascaderAll from '@/views/workOrder/components/cascaderAll';
import {uniqBy, throttle, debounce} from 'lodash'
import {batchSelectModal} from "@/components/modal"
import APICOMMON from "@/api/dataCenter/appKpi.js"
import API from "@/api/workOrder/store.js"
import dayjs from 'dayjs';
export default {
    name: 'storePage_query',
    components: {
        CustomInput,
        FilterPopSelect,
        SelectAll,
        CascaderAll
    },
    props:['query'],
    data() {
        return {
            basePickerOptions: {
                firstDayOfWeek: 1,
                shortcuts: [
                    {
                        text: '最近7天',
                        onClick(picker) {
                            const date = new Date();
                            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
                            let endDate = new Date(date.getTime());
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上周',
                        onClick(picker) {
                            // 上周：自然周，周一到周日
                            let date = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 7);
                            let weekDay = date.getDay();
                            let startDate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * (weekDay === 0 ? 6 : weekDay - 1));
                            let endDate = new Date(startDate.getTime() + 1000 * 60 * 60 * 24 * 6);
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = year + '-' + month + '-1';
                            let endDate = year + '-' + month + '-' + day;
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            let startDate = new Date(year + '-' + month + '-01');
                            let endDate = new Date(new Date(year + '-' + (month + 1) + '-01').getTime() - 1000 * 60 * 60 * 24);
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '本季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = '';
                            if ([1, 2, 3].includes(month)) {
                                startDate = year + '-01-01';
                            } else if ([4, 5, 6].includes(month)) {
                                startDate = year + '-04-01';
                            } else if ([7, 8, 9].includes(month)) {
                                startDate = year + '-07-01';
                            } else if ([10, 11, 12].includes(month)) {
                                startDate = year + '-10-01';
                            }
                            let endDate = year + '-' + month + '-' + day;
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;

                            let startDate = '';
                            let endDate = '';
                            if ([1, 2, 3].includes(month)) {
                                startDate = (year - 1) + '-10-01';
                                endDate = (year - 1) + '-12-31';
                            } else if ([4, 5, 6].includes(month)) {
                                startDate = year + '-01-01';
                                endDate = year + '-03-31';
                            } else if ([7, 8, 9].includes(month)) {
                                startDate = year + '-04-01';
                                endDate = year + '-06-30';
                            } else if ([10, 11, 12].includes(month)) {
                                startDate = year + '-07-01';
                                endDate = year + '-09-30';
                            }
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '今年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let startDate = year + '-01-01';
                            let endDate = year + '-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '去年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear() - 1;
                            let startDate = year + '-01-01';
                            let endDate = year + '-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    }
                ]
            },
            defaultOptions:{
                plat:[],
                delivery_scene:[],
                delivery_type:[],
                material_type:[],
                is_used:[],
                app_type:[],
                game_classify:[],
                material_format:[],
                project_tag11:[],
                project_tag12:[]
            },
            dictData: {},
            work_order_DataList: [],
            project_id_DataList: [],
            material_name_DataList: [],
            material_md5_DataList: [],
            production_user_DataList: [],
            director_DataList: [],
            label_ids_DataList: [],
            detail_id_DataList: [],
            material_w_h_DataList:[],
            material_group_DataList:[],
            create_order_uid_DataList: [],
            create_material_group_DataList: [],
            material_label_DataList: [],
            formData: {
                material_size_unit: '1', //素材大小
                is_used: [], //使用状态
                material_id: [],  //素材名称
                material_md5: [],  //素材MD5
                material_type: [], //素材类型
                material_format: [], //素材格式
                material_w_h: [], //素材尺寸
                material_size: '', //素材大小
                label_ids: [], //素材标签
                source: [],  //内部来源
                producer_uid: [], //制作人
                material_group: [], //制作部门
                upload_time: [ dayjs().subtract(180, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD') ],  //素材上传时间
                project_id: [],  //项目名称
                project_type: [], //指定项目
                app_type: [], //产品类型
                package_type: [], //包体类型
                game_classify: [],  //游戏分类
                work_order: [],  //工单
                detail_id: [],  //任务ID
                plat_id: '',  //媒体
                delivery_scene: '',  //投放场景
                delivery_type: '', //投放版位
                create_order_uid: [], //需求方
                create_material_group: [],  //需求方部门
                material_label: [], //素材标签分类
            },
            listMap:[
                {
                    name: "is_used",
                    label: "使用状态",
                    default_check: true,
                },
                {
                    name: "material_id",
                    label: "素材名称",
                },
                {
                    name: "material_md5",
                    label: "素材MD5",
                    default_check: true,
                },
                {
                    name: "material_type",
                    label: "素材类型",
                    default_check: true,
                },
                {
                    name: "material_format",
                    label: "素材格式",
                },
                {
                    name: "material_w_h",
                    label: "素材尺寸",
                    default_check: true,
                },
                {
                    name: "material_size",
                    label: "素材大小",
                },
                {
                    name: "label_ids",
                    label: "素材标签",
                },
                {
                    name: "source",
                    label: "内部来源",
                },
                {
                    name: "producer_uid",
                    label: "制作人",
                },
                {
                    name: "material_group",
                    label: "制作部门",
                },
                {
                    name: "upload_time",
                    label: "素材上传时间",
                },
                {
                    name: "project_id",
                    label: "项目名称",
                    default_check: true,
                },
                {
                    name: "project_type",
                    label: "指定项目",
                },
                {
                    name: "app_type",
                    label: "产品类型",
                },
                {
                    name: "package_type",
                    label: "包体类型",
                },
                {
                    name: "game_classify",
                    label: "游戏分类",
                },
                {
                    name: "work_order",
                    label: "工单",
                },
                {
                    name: "detail_id",
                    label: "任务ID",
                },
                {
                    name: "plat_id",
                    label: "媒体",
                },
                {
                    name: "delivery_scene",
                    label: "投放场景",
                },
                {
                    name: "delivery_type",
                    label: "投放版位",
                },
                {
                    name: "create_order_uid",
                    label: "需求方",
                },
                {
                    name: "create_material_group",
                    label: "需求方部门",
                },
                {
                    name: "material_label",
                    label: "素材分类标签",
                },
                {
                    name: "project_tag11",
                    label: "游戏类型",
                },
                {
                    name: "project_tag12",
                    label: "游戏题材",
                },
                
            ],
            customFilter: [], // ['plat_id', 'delivery_scene', 'delivery_type', 'material_type', 'material_w_h', 'label_ids', 'is_used'],
            searchLoading:false,
            loading: false,
            game_classify_disabled: false,
        }
    },
    watch:{
        'formData.plat_id'(val) {
                if(val) {
                    this.fetchDeliveryOptions(val, 'delivery_scene')
                }else{
                    this.defaultOptions['delivery_scene'] = []
                }
                this.formData.delivery_scene = ''
        },
        'formData.delivery_scene'(val) {
            if(val) {
                this.fetchDeliveryOptions(this.formData.plat_id, 'delivery_type', val)
            }else{
                this.defaultOptions['delivery_type'] = []
            }
            this.formData.delivery_type = ''
        },
        'formData.app_type'(val='') {
            if(val.length === 1 && val[0] == '1') {
                this.game_classify_disabled = true
                this.formData.game_classify = []
            }else{
                this.game_classify_disabled = false
            }
        }
    },
    mounted() {
        this.fetchGetCustomFilter()
        // let query_md5 = this.$route.query.md5
        // let material_type = this.$route.query.material_type
        // let project_id_DataList = this.$route.query.project
        const {md5, material_type, project, is_used, material_w_h_DataList} = this.$route.query

        this.$nextTick(()=>{
            if(md5) {
                let md5_array = md5.split(',')
                this.material_md5_DataList = md5_array.map(item=>{
                    return {
                        value: item,
                        label: item
                    }
                })
                this.formData.material_md5 = md5_array
            }
            if(material_type && project && is_used && material_w_h_DataList) {
                this.formData.material_type = material_type.split(',').map(item=>Number(item))
                this.formData.is_used = is_used.split(',').map(item=>Number(item))


                let toJsonListProject = JSON.parse(decodeURIComponent(project))
                let toJsonListWh = JSON.parse(decodeURIComponent(material_w_h_DataList))

                // 项目名称赋值
                this.formData.project_id = toJsonListProject.map(item=>item.value)
                this.project_id_DataList = toJsonListProject

                // 素材尺寸赋值
                this.formData.material_w_h = toJsonListWh.map(item=>item.id)
                this.material_w_h_DataList = uniqBy([...toJsonListWh, ...this.material_w_h_DataList], 'id')
            }

            this.handleOnSubmit()
        })

    },
    methods:{
        fetchGetCustomFilter() {
            this.loading = true
            APICOMMON.getCustomFilter({field_type: 'work_order_material_filter'}).then(res=>{
                this.loading = false
                if(res.data && res.data.length>0){
                    this.customFilter = res.data
                }
                this.fetGetSearchList()
                this.fetchGetSearchOther()
            }, err=>{
                this.loading = false
                this.$message.error(err.info)
            }).finally(()=>{
                // this.handleOnSubmit()
            })
        },
        fetchSetCustomFilter(values) {
            let res_filter = this.listMap.filter(item=>values.includes(item.name))
            APICOMMON.setCustomFilter({field_type: 'work_order_material_filter', filters: res_filter}).then(res=>{
                this.$message.success('成功')
            })
        },
        //部分 下拉枚举值
        fetGetSearchList() {
            API.getSearchWorkOrderOptions({type: 'material'}).then(res=>{
                // this.$message.success('成功')
                this.defaultOptions = res.data
            }, err=>{
                this.$message.error(err.info)
            })
        },
        //部分 远程搜索下拉枚举值
        fetchGetSearchOther() {
            let forArray = ['production_user', 'director', 'label_ids','material_group', 'material_w_h', 'create_order_uid', 'create_material_group', 'material_label']
            forArray.forEach((item)=>{
                API.postSearchStoreMethodOptions({search:'',batch_search:'',search_type: item}, {cancel: false}).then(res=>{
                    console.log('res',res)
                    if(item === 'label_ids' || item === 'material_group' || item === 'create_material_group') {
                        this[`${item}_DataList`]= res.data.list
                    }else{
                        this[`${item}_DataList`]= res.data.list.map(v=> {
                            return {
                                ...v,
                                value: v.id,
                                label: v.name
                            }
                        })
                    }

                }, err=>{
                    this.$message.error(err.info)
                })
            })
        },
        // 投放场景 投放版位联动
        fetchDeliveryOptions(plat_id, type, id) {
            // delivery_scene投放场景 delivery_type投放版位
            let params = {
                plat_id: plat_id,
                search_type: type,
            }
            if(!plat_id) {
                return this.$message.error('请选择媒体')
            }
            if(!id) {
                if(type === 'delivery_type') {
                    return this.$message.error('请选择投放场景')
                }
            }else{
                params['delivery_scene_id'] = id
            }
            API.getSearchDeliveryOptions(params).then(res=>{
                let options = res.data.map(v=> {
                    return {
                        id: v[`${type}_id`],
                        name: v[type]
                    }
                })
                this.$set(this.defaultOptions, type, options)
                console.log('pp', type, this.defaultOptions)
            }, err=>{
                this.$message.error(err.info)
            })
        },
        changeFilter(values) {
            console.log('筛选', values)
            this.customFilter = values
            this.resetData(this.customFilter)
        },
        // 删除
        handleDel(name) {
            let del_index = this.customFilter.findIndex(item=>item == name);
            this.customFilter.splice(del_index, 1)
            this.resetData(this.customFilter)
        },
        // 重置form变量
        resetData(values) {
            if(Array.isArray(values)) {
                for (let key in this.formData) {
                    if (!values.includes(key)) {
                        this.formData[key] = null;
                    }
                }
                this.formData.material_size_unit = '1'
            }
            this.fetchSetCustomFilter(values)
        },
        // 表单项 显示与隐藏
        getCustomFilterShow(name) {
            return this.customFilter.includes(name)
        },
        // 下拉检索
        throttleAppEntrySearchList: debounce(function(search, type, p ={}, cb) {
            this.appEntrySearchList(search, type, p ={}, cb)
        }, 300),
        async appEntrySearchList(search, type, p ={}, cb) {
            try {
                const params = {
                    search_type: type,
                    search,
                    ...p
                };
                this.searchLoading = true
                const { data } = await API.postSearchStoreMethodOptions(params);
                const list = data.list;
                const errList = data.err_list;
                if (params.batch_search) {
                    cb(errList, ()=> {
                        const ids = list.map(v=>v.id)
                        this[`${type}_DataList`] = [
                            ...this[`${type}_DataList`].filter(v=>this.formData[type].includes(v.value)&&!ids.includes(v.value)),
                            ...list.map(v=> {
                                return {
                                    ...v,
                                    value: v.id,
                                    label: v.name
                                }
                            })
                        ]
                        this.formData[type] = [...new Set([ ...this.formData[type], ...ids ])];
                    })
                }else {
                    this[`${type}_DataList`]= list.map(v=> {
                        return {
                            ...v,
                            value: v.id,
                            label: v.name
                        }
                    })
                }
            } catch (error) {
                this.$message.warning(error.info)
            } finally {
                this.searchLoading = false
            }
        },

        handleGenAppendClick(type, placeholder) {
            const onSubmit = (data, callback)=> {
                this.appEntrySearchList(
                    '',
                    type,
                    {
                        batch_search: data,
                    },
                    (errs, cb)=> {
                        callback();
                        if (errs.length) {
                            delErrList({
                                tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                list: errs,
                                onOk: ()=> {
                                    cb();
                                    vm.close();
                                }
                            })
                        }else {
                            cb();
                            vm.close();
                        }
                    }
                )
            }
            const { vm, delErrList } = batchSelectModal({
                title: '批量添加',
                props: {
                    tip: placeholder ? placeholder : '输入或粘贴名称或ID，每行一个',
                    hasLoading: true
                },
                cbs: {
                    onSubmit
                }
            })
        },
        handleVisibleChange(visible, type) {
            if (visible) {
                const options = this.$refs[type].selected|| [];
                const listData = options.map(v=> {
                    return v.$options.propsData
                });
                this.$set(this, `${type}_DataList`, listData)
            }
        },
        handleSelectAll(list, type, selectType) {
            if(selectType === 'all') {
                const data = [...(this.formData[type] || [])];
                data.push(...list.map(v=>v.value));
                // 去重 赋值
                this.formData[type] = [ ...new Set(data)]
            }else{
                let optionList_ids = this[`${type}_DataList`].map(item=>item.value)
                let channel_ids = this.formData[type].filter(item=> !optionList_ids.includes(item))
                this.formData[type] = [...channel_ids]
            }
        },
        handleOnSubmit() {
            let params = {}
            for (let key in this.formData) {
                params[key] = this.formData[key]
            }
            let res_upload_time = this.formData.upload_time ? this.formData.upload_time.join('/') : ''; //时间的格式处理
            params['upload_time'] = res_upload_time

            if(Object.keys(this.$route.query).length != 0) {
                // this.$router.push({name:'material', query:{}})
            }
            this.$emit('query-click', params)
        },
        //清空
        resetForm() {
            this.$refs['formInline'].resetFields();
            this.$refs.cascaderAll.choiceEle = []
            this.$refs.cascaderAllGroup.choiceEle = []
            this.formData.material_size_unit = '1'
            this.formData.is_used = []
            this.formData.material_id = []
            this.formData.material_md5 = []
            this.formData.material_type = []
            this.formData.material_format = []
            this.formData.material_w_h = []
            this.formData.material_size = ''
            this.formData.label_ids = []
            this.formData.source = []
            this.formData.producer_uid = []
            this.formData.material_group = []
            this.formData.upload_time = [ dayjs().subtract(180, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
            this.formData.project_id = []
            this.formData.project_type = []
            this.formData.app_type = []
            this.formData.game_classify = []
            this.formData.work_order = []
            this.formData.detail_id = []
            this.formData.plat_id = ''
            this.formData.delivery_scene = ''
            this.formData.delivery_type = ''
            this.formData.create_order_uid = []
            this.formData.create_material_group = []
            this.formData.project_tag11 = []
            this.formData.project_tag12 = []
            this.formData.material_label = []

            if(Object.keys(this.$route.query).length != 0) {
                // this.$router.push({name:'material', query:{}})
            }
            this.$nextTick(()=>{
                this.handleOnSubmit()
            })
        },
        changeNum(val,name) {
            const newValue = val.replace(/[^\d]/g, '');
            if (/^[1-9]\d*$/.test(newValue)) {
                this.formData[name] = Number(newValue);
            } else {
                this.formData[name] = '';
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.opts {
    border-top: 1px solid #DCDFE6;
    padding-top: 10px;
}
.form-box {
    background: #ffffff;
    padding: 20px 10px;
    border-radius: 4px;
    &::v-deep {
        .el-form-item {
            margin-bottom: 10px;
        }
    }
}
.table-context {
    background-color: #fff;
    margin-top: 12px;
    border-radius: 4px;
    padding-top: 12px;
}
.storeFlex{
    display: inline-flex;
    width: 220px;
    align-items: center;
    overflow: hidden;
}
</style>

